export default __webpack_public_path__ + "static/media/march-2021.320c8445.csv";